import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNotificationSetting } from "../../../actions/ProfileAction";
import Notify from "../../Common/Notify";

const NotificationSetting = ({ notificationType = 1 }) => {
  const [setting, setSetting] = useState(notificationType);
  const dispatch = useDispatch();

  useEffect(() => {
    //
  }, []);

  const updateNotification = (newSetting) => {
    let prev_setting = setting;
    setSetting(newSetting);
    dispatch(updateNotificationSetting(newSetting))
      .then((res) => {
        if (res.result && res.result.userSettings) {
          Notify.info("Successfully updated notification.");
        } else {
          Notify.error("Failed to update notification.");
          setSetting(prev_setting);
        }
      });
  };

  return (
    <div className="Notification-Setting-Container" style={{ minWidth: "450px" }}>
      <div className="Form-Container">
        <form style={{ position: "relative" }}>
          <h5
            style={{
              fontSize: "1rem",
              fontWeight: "500",
              marginBottom: "20px"
            }}
          >
            Notification Settings
          </h5>
          <div className="detail-container">
            {[
              "Important Messages Only",
              "All Notifications",
              "Mute All Notifications",
              "Urgent Messages only",
              "Attention Messages only",
            ].map((label, index) => (
              <div className="radio" key={index}>
                <label className={setting === index ? "hc-primary-text" : ""}>
                  <input
                    className="mr-1"
                    type="radio"
                    name="optradio"
                    value={index}
                    checked={setting === index}
                    onChange={() => updateNotification(index)}
                  />
                  <span>{label}</span>
                </label>
              </div>
            ))}
          </div>
        </form>
      </div>
    </div>
  );
};

export default NotificationSetting;
